import { observable, action, decorate } from 'mobx'
import axios from 'axios'

class RequestsStore {
  constructor (rootStore) {
    this.state = {
      requests: new Map(),
      isFetching: []
    }
    this.rootStore = rootStore.stores
  }

  fetchRequests (company, product) {
    console.log(company)
    if (!this.state.requests.has(company)) {
      this.state.requests.set(company, new Map())
    }
    if (!this.state.requests.get(company).has(product)) {
      this.state.requests.get(company).set(product, {isFetching: false, data: [], isDone: false})
    }
    this.state.requests.get(company).get(product).isFetching = true
    const url = process.env.REACT_APP_AWS_URL + '/getRequests/'
    axios.post(url, {
      company: company,
      product: product
    })
    .then(response => {
      this.state.requests.get(company).get(product).data = response.data
      this.state.requests.get(company).get(product).isFetching = false
      this.state.requests.get(company).get(product).isDone = true
      console.log(this.state.requests.get(company).get(product))
    })
    .catch(error => {
      this.state.requests.get(company).get(product).isFetching = false
      console.log(error)
    })
  }

  downloadRequest (link, isDownloaded, key, companyName, productName) {
    window.open(link)
    const url = process.env.REACT_APP_AWS_URL + '/checkRequestDownload'
    if (!isDownloaded) {
      axios.post(url, {
        companyName: companyName,
        key: key,
        product: productName
      })
      .then(response => {
        const companies = this.rootStore.userStore.state.companies.map(company => company.id)
        this.rootStore.userStore.getCompanyInfo(companies)
      })
      .catch(error => {
        console.log(error)
      })
    }
  }
}

decorate(RequestsStore, {
  state: observable,
  fetchRequests: action
})

export default RequestsStore



// WEBPACK FOOTER //
// ./src/stores/requestsStore.js